import { useSelector } from 'react-redux'

import { useGoustoAnytimeMenuVariant } from 'routes/Menu/experiments/GoustoAnytime/useGoustoAnytimeMenuVariant'
import { isBasketTransactionalOrder } from 'selectors/basket'

export const useIsBasketInGoustoAnytimeDiscountPopulation = (): boolean => {
  const isInGoustoAnytimeVariant = useGoustoAnytimeMenuVariant()
  const isTransactionalOrder = useSelector(isBasketTransactionalOrder)

  return isInGoustoAnytimeVariant && isTransactionalOrder
}
